import moment from "moment";
import react from "react";

export function Moment(cDate, uDate, type) {
  // return moment(cDate).format("lll");
  if (type == "create") {
    if (cDate == undefined) {
      return "Date Not Provided";
    } else {
      return moment(cDate).format("lll");
    }
  } else {
    if (uDate == undefined) {
      return "Date Not Provided";
    }

    var date = new Date(
      "Mon Jul 25 2022 10:50:18 GMT+0530 (India Standard Time)"
    );
    var date1 = new Date(uDate);
    // var date1 = new Date("2022-07-31T09:28:51.803Z");

    // console.log("DDDD", date, date1, date < date1);

    if (date < date1) {
      return moment(uDate).format("lll");
    } else {
      return moment(cDate).format("lll");
    }
  }
}
